import { light } from './light';
import { dark } from './dark';
export const THEME = {
    DARK: 'dark',
    LIGHT: 'light',
};
export const DEFAULT_THEME = THEME.LIGHT;
export const themes = {
    [THEME.LIGHT]: {
        name: 'light',
        colors: light,
        invertedColors: dark,
    },
    [THEME.DARK]: {
        name: 'dark',
        colors: dark,
        invertedColors: light,
    },
};
